// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextDashboard } from '../Dashboard.context';

// mui
import { Container, Grid } from '@mui/material';

// cards
import { CardKeyValue } from '../../../cards/CardKeyValue/CardKeyValue';

// utils
import { formatNumber } from '../../../../utils/format';

export const Summary = () => {
	const { isLoadingGeneral, statsGeneral } = useContext(ContextDashboard);
	const { t } = useTranslation();

	const cards = [
		{
			IconCircleProps: { type: 'project' as const },
			label: { children: t('projects') },
			total: statsGeneral?.projects?.total || 0,
		},
		{
			IconCircleProps: { type: 'location' as const },
			label: { children: t('countries') },
			total: statsGeneral?.countries?.total || 0,
		},
		{
			IconCircleProps: { type: 'loan' as const },
			label: { children: t('financingSources') },
			total: statsGeneral?.loans?.total || 0,
		},
		{
			IconCircleProps: { type: 'account' as const },
			label: { children: t('accounts') },
			total: statsGeneral?.accounts?.total || 0,
		},
		{
			IconCircleProps: { type: 'entity' as const },
			label: { children: t('entities') },
			total: statsGeneral?.entities?.total || 0,
		},
		{
			IconCircleProps: { type: 'user' as const },
			label: { children: t('users') },
			total: statsGeneral?.users?.total || 0,
		},
		{
			IconCircleProps: { type: 'contract' as const },
			label: { children: t('contracts') },
			total: statsGeneral?.contracts?.total || 0,
		},
		{
			IconCircleProps: { type: 'payment' as const },
			label: { children: t('transactions') },
			total: statsGeneral?.transactions?.total || 0,
		},
	];

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				{cards.map((card, index) => (
					<Grid item key={index} lg={3} xs={6}>
						<CardKeyValue
							IconCircleProps={card.IconCircleProps}
							isLoading={isLoadingGeneral}
							label={card.label}
							value={{ children: formatNumber(card.total) }}
						/>
					</Grid>
				))}
			</Grid>
		</Container>
	);
};
